
/*********filters on desktop position sticky code starts here */
document.addEventListener("scroll", function() {
  const sidebar = document.querySelector(".sticky-sidebar-wrapper");
  if (!sidebar) return;

  const footer = document.querySelector(".pagination"); // or a more specific footer selector
  if (!footer) return;

  const sidebarParent = sidebar.closest(".grid__item--sidebar") || sidebar.parentElement;

  const scrollY = window.scrollY || window.pageYOffset;
  const triggerPoint = 200; // when sticky starts
  const topOffset = 130; // height of your header (adjust)
  //const stopOffset = 270; // gap above footer
  const stopOffset = 700; // gap above footer

  const sidebarHeight = sidebar.offsetHeight;
  const footerTop = footer.getBoundingClientRect().top + window.scrollY;
  const maxScroll = footerTop - sidebarHeight - stopOffset;
  
  // Stick when scrolling past triggerPoint, but unstick before footer
  if (scrollY > triggerPoint && scrollY < maxScroll) {
    sidebar.style.position = "sticky";
    sidebar.style.top = topOffset + "px";
    sidebar.style.bottom = "auto";
  } else if (scrollY >= maxScroll) {
    sidebar.style.position = "relative";
    sidebar.style.top = "auto";
    sidebar.style.bottom = stopOffset + "px";
  } else {
    sidebar.style.position = "relative";
    sidebar.style.top = "0";
  }
});
/*********downpayment code start here */
document.addEventListener('DOMContentLoaded', function () {
 // const cartDrawer = document.querySelector('#CartDrawer, .cart-drawer, .drawer--cart');
  const cartDrawer = document.querySelector('#CartDrawer, .drawer--is-open');
 // .drawer, .drawer--right, .drawer--is-open

  if (!cartDrawer) {
    console.warn('Cart drawer not found on page.');
    return;
  }

  // Watch for class changes
  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        if (cartDrawer.classList.contains('drawer--is-open')) {
          // Drawer just opened
          onCartDrawerLoad();
        }
      }
    }
  });

  observer.observe(cartDrawer, { attributes: true });

  function onCartDrawerLoad() {
     fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const hasTestSku = cart.items.some(item => item.sku && item.sku.includes('TEST'));

      if (hasTestSku) {
        // Hide Go To Shopping Bag if TEST item is added
         var gottoshoppingbag = document.getElementById('btn-go-to-cart');
         if (gottoshoppingbag) {
          gottoshoppingbag.style.display = 'none';
        }
      }

      let shouldAdd = false;
      no_oftryathomeitems = 0;

      // Check if any product's SKU contains 'TEST'
      cart.items.forEach(item => {
        if (item.sku && item.sku.includes('TEST')) {
          shouldAdd = true;
          no_oftryathomeitems = no_oftryathomeitems + 1;

        }
      });

       const alreadyInCart = cart.items.some(item => item.variant_id === 47295616385248);
       const alreadyInCart2 = cart.items.some(item => item.variant_id === 47295616418016);
       const alreadyInCart3 = cart.items.some(item => item.variant_id === 47295616450784);
      const rntagVariant = cart.items.find(item => item.variant_id === 47295616385248);
       const rntagVariant1 = cart.items.find(item => item.variant_id === 47295616418016);
       const rntagVariant2 = cart.items.find(item => item.variant_id === 47295616450784);

    //check how many nooftryathomeitems is added in the cart
    if(no_oftryathomeitems ==1){

       if (alreadyInCart2) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant1.key, // use the line item key to remove
            quantity: 0
          })
        })
       
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }

       if (alreadyInCart3) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant2.key, // use the line item key to remove
            quantity: 0
          })
        })
       
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }
      
      if (shouldAdd && !alreadyInCart) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: 47295616385248,
            quantity: 1,
            selling_plan: 5804916960
          })
        })
          
        .catch(error => {
          console.error('Error adding the auto-added product:', error);
        });
      
      }
        
     
    }
      else if (no_oftryathomeitems == 2){

       if (alreadyInCart) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant.key, // use the line item key to remove
            quantity: 0
          })
        })
       
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }
       if (alreadyInCart3) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant2.key, // use the line item key to remove
            quantity: 0
          })
        })
       
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }

        if (shouldAdd && !alreadyInCart2) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: 47295616418016,
            quantity: 1,
            selling_plan: 5804916960
          })
        })
         
        .catch(error => {
          console.error('Error adding the auto-added product:', error);
        });

      }
      
    }
    else if(no_oftryathomeitems ==3){

       if (alreadyInCart2) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant1.key, // use the line item key to remove
            quantity: 0
          })
        })
      
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }

        if (alreadyInCart) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant.key, // use the line item key to remove
            quantity: 0
          })
        })
       
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }

        if (shouldAdd && !alreadyInCart3) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: 47295616450784,
            quantity: 1,
            selling_plan: 5804916960
          })
        })
        .catch(error => {
          console.error('Error adding the auto-added product:', error);
        });
      }
        
      }

      
    })
    .catch(error => {
      console.error('Error checking cart contents:', error);
    });
    // Your code here

  }
});


// Auto-add variant ID 47295616385248 if cart has any item with SKU containing "TEST"

document.addEventListener("DOMContentLoaded", function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let shouldAdd = false;
      no_oftryathomeitems = 0;

      // Check if any product's SKU contains 'TEST'
      cart.items.forEach(item => {
        if (item.sku && item.sku.includes('TEST')) {
          shouldAdd = true;
          no_oftryathomeitems = no_oftryathomeitems + 1;

        }
      });

       const alreadyInCart = cart.items.some(item => item.variant_id === 47295616385248);
       const alreadyInCart2 = cart.items.some(item => item.variant_id === 47295616418016);
       const alreadyInCart3 = cart.items.some(item => item.variant_id === 47295616450784);
      const rntagVariant = cart.items.find(item => item.variant_id === 47295616385248);
       const rntagVariant1 = cart.items.find(item => item.variant_id === 47295616418016);
       const rntagVariant2 = cart.items.find(item => item.variant_id === 47295616450784);

      
      // If no more "TEST" SKUs and RNTAGT1 is still in the cart, remove it
      if (!shouldAdd && rntagVariant){
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant.key, // use the line item key to remove
            quantity: 0
          })
        })
        .then(() => {
          // Reload to reflect removal
          window.location.reload();
        })
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
      }

       if (!shouldAdd && rntagVariant1){
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant1.key, // use the line item key to remove
            quantity: 0
          })
        })
        .then(() => {
          // Reload to reflect removal
          window.location.reload();
        })
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
      }

       if (!shouldAdd && rntagVariant2){
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant2.key, // use the line item key to remove
            quantity: 0
          })
        })
        .then(() => {
          // Reload to reflect removal
          window.location.reload();
        })
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
      }

      //check how many nooftryathomeitems is added in the cart
    if(no_oftryathomeitems ==1){

       if (alreadyInCart2) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant1.key, // use the line item key to remove
            quantity: 0
          })
        })
       
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }

       if (alreadyInCart3) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant2.key, // use the line item key to remove
            quantity: 0
          })
        })
       
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }
      
      if (shouldAdd && !alreadyInCart) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: 47295616385248,
            quantity: 1,   
            selling_plan: 5804916960
          })
        })

        .catch(error => {
          console.error('Error adding the auto-added product:', error);
        });
      }
      
    }else if (no_oftryathomeitems == 2){

       if (alreadyInCart) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant.key, // use the line item key to remove
            quantity: 0
          })
        })
       
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }
       if (alreadyInCart3) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant2.key, // use the line item key to remove
            quantity: 0
          })
        })
       
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }

        if (shouldAdd && !alreadyInCart2) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: 47295616418016,
            quantity: 1,
            selling_plan: 5804916960
          })
        })
        .then(() => {
          // Optionally reload to update the cart
        //  window.location.reload();
        })
        .catch(error => {
          console.error('Error adding the auto-added product:', error);
        });
      }
      
    }
     else if(no_oftryathomeitems ==3){

       if (alreadyInCart2) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant1.key, // use the line item key to remove
            quantity: 0
          })
        })
      
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }

        if (alreadyInCart) {
          fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rntagVariant.key, // use the line item key to remove
            quantity: 0
          })
        })
       
        .catch(error => {
          console.error('Error removing the auto-added product:', error);
        });
       }

        if (shouldAdd && !alreadyInCart3) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: 47295616450784,
            quantity: 1,
            selling_plan: 5804916960
          })
        })
        .then(() => {
          // Optionally reload to update the cart
        //  window.location.reload();
        })
        .catch(error => {
          console.error('Error adding the auto-added product:', error);
        });
      }
        
      }

    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });

  
});

//STop to remove the rental agreement product if the product is in cart.
document.addEventListener("DOMContentLoaded", function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let hasTestSku = false;

      cart.items.forEach(item => {
        if (item.sku && item.sku.includes('TEST')) {
          hasTestSku = true;
        }
      });

      if (hasTestSku) {
        // Protect variant ID 47295616385248 from being removed
        const formSelectors = document.querySelectorAll('form[action^="/cart/change"], form[action^="/cart/update"]');

        formSelectors.forEach(form => {
          const inputs = form.querySelectorAll('input[name="updates[]"], input[name="quantity"]');
          inputs.forEach(input => {
            const lineItemElement = input.closest('[data-cart-item], [data-line-item]') || input.closest('tr');
            if (lineItemElement) {
              const variantId = lineItemElement.dataset.variantId || lineItemElement.getAttribute('data-variant-id');
              
              if (variantId == '47295616385248') {
                input.disabled = true; // Disable changing/removing the protected item
                input.closest('form').querySelector('button[type="submit"], input[type="submit"]')?.setAttribute('disabled', true);
              }
            }
          });
        });

        // Also disable "remove" buttons if they exist
        const removeButtons = document.querySelectorAll('a[href*="/cart/change"], button[name="remove"]');
        removeButtons.forEach(button => {
          if (button.href && button.href.includes('variant=47295616385248')) {
            button.style.pointerEvents = 'none';
            button.style.opacity = '0.5';
            button.title = "This product cannot be removed while TEST items are in the cart.";
          }
        });
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
});


// testing to select all checkbox in color
function ivorycolor(){
//  alert("here");
    if(document.getElementById('ivorycolor').checked){
     //   window.location='https://www.yousendit.com/dropbox?dropbox=mydomain';
        return false;
    }
    return true;

}
function colorunblackornude( id, filterParamName, filterParamValue ){  
     var ele=document.getElementsByName('filter.v.option.color');  
                for(var i=0; i<ele.length; i++){                  
                    if(ele[i].type=='checkbox' && (ele[i].value == 'Black/Nude' || ele[i].value == 'Black/Black' || ele[i].value == 'Ivory/Nude' || ele[i].value == 'Ivory/Champagne' || ele[i].value == 'Ivory/Sand' || ele[i].value == 'Ivory/Blush') )  
                        ele[i].checked=false;  
                }  
 }  
function colorunivoryornude( id, filterParamName, filterParamValue ){  
     var ele=document.getElementsByName('filter.v.option.color');  
                for(var i=0; i<ele.length; i++){                  
                    if(ele[i].type=='checkbox' && (ele[i].value == 'Ivory1' || ele[i].value == 'White' || ele[i].value == 'Ivory/Nude' || ele[i].value == 'Ivory/Champagne' || ele[i].value == 'Ivory/Sand' || ele[i].value == 'Ivory/Blush') )  
                        ele[i].checked=false;  
                }  
 }  
function colorunivoryorblack( id, filterParamName, filterParamValue ){  
     var ele=document.getElementsByName('filter.v.option.color');  
                for(var i=0; i<ele.length; i++){                  
                    if(ele[i].type=='checkbox' && (ele[i].value == 'Black/Nude' || ele[i].value == 'Black/Black' || ele[i].value == 'Ivory1' || ele[i].value == 'White' ) )  
                        ele[i].checked=false;  
                }  
 }  
// Separated Filter 
function multipleChecked( id, filterParamName, filterParamValue ){
  return false;
  let arrayOfCheckedItems = [];
  document.querySelectorAll(`#${ id } input[name="filter.p.m.global.${filterParamName}"].${filterParamName}_show`)
    .forEach(opt => {
      if ( opt.checked == true && !arrayOfCheckedItems.includes( filterParamValue ) ) {
        arrayOfCheckedItems.push(opt.value);
      }
    });
  
  // Loop through all the hidden fields and if any keyword from the
  // arrayOfCheckedItems exists in the hidden field value, check the
  // field.
  let hiddenFields = document.querySelectorAll(`input[name="filter.p.m.global.${filterParamName}"].${filterParamName}_hidden`);
  hiddenFields.forEach(opt => {
    if (arrayOfCheckedItems.some(k => opt.value.includes(k))){
      opt.checked = true;
    } else {
      opt.checked = false;
    }
  });

}
// End Separated Filter 

// Sort size variant options for TAH
const sizeOptions = document.querySelector(`[data-handle="size"]`);
if( sizeOptions ) {
 [...sizeOptions.children]
  .sort( ( a, b ) => Number((a.innerText).split('-')[0]) > Number((b.innerText).split('-')[0]) ? 1 : -1 )
  .forEach( node => sizeOptions.appendChild( node ) ); 
}
// End sort size variant options for TAH

// KLARNA
const priceEl = document.querySelector(".product__price");
if( priceEl ) {
  const price = (priceEl.innerHTML).replace('$', '').split('.')[0];
  const klarnaMessage = document.querySelector('#shopify-block-ec8e3ae1-3514-4056-9e4c-393f7fa29896');  
  if( Number( price | 0 ) < 50 ) {
    const hideKlarna = `#shopify-block-ec8e3ae1-3514-4056-9e4c-393f7fa29896{display: none}`;
    const styleSheet = document.createElement("style");
    styleSheet.innerText = hideKlarna;
    document.head.appendChild(styleSheet);
  }
}

const freeShippingEl = document.querySelector("#free-shipping");
if( !freeShippingEl ) {
  const hideKlarna = `#shopify-block-ec8e3ae1-3514-4056-9e4c-393f7fa29896{margin-top: -60px}`;
  const styleSheet = document.createElement("style");
  styleSheet.innerText = hideKlarna;
  document.head.appendChild(styleSheet);
}
// END KLARNA 

// Product Swiper
const productRecommendations = document.querySelector('div[data-section-type="product-recommendations"]');
if( productRecommendations && Swiper ){
  let swp;
  document.addEventListener('DOMNodeInserted', function addSwiper(e) {
    const productSwiper = document.querySelector(".product-swiper");
    if ( productSwiper && !swp ) {
      document.removeEventListener('DOMNodeInserted', addSwiper);
      swp = new Swiper(".product-swiper", {
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            
          },
          768: {
            slidesPerView: 3,
            
          },
          1024: {
            slidesPerView: 4,
            
          },
        },
      });
    }
  })
}
// End Product Swiper

// Remove duplicate color options
const colorOptions = document.querySelectorAll(".variant-input[data-index='option1']");
if ( colorOptions.length ){
  let exist = [];
  for (let i = 0; i < colorOptions.length; i++) {
    if ( exist.includes( colorOptions[i].getAttribute('data-value') ) ){
      colorOptions[i].parentNode.removeChild( colorOptions[i] )
    }else{
      exist.push( colorOptions[i].getAttribute( 'data-value' ) ); 
    }
  }
}

// End Remove duplicate color options

// Remove duplicate size options
const sizeOptionsButton = document.querySelectorAll(".variant-input[data-index='option2']");
if ( sizeOptionsButton.length ){
  let exist = [];
  for (let i = 0; i < sizeOptionsButton.length; i++) {
    if ( exist.includes( sizeOptionsButton[i].getAttribute('data-value') ) ){
      sizeOptionsButton[i].parentNode.removeChild( sizeOptionsButton[i] )
    }else{
      exist.push( sizeOptionsButton[i].getAttribute( 'data-value' ) ); 
    }
  }
}

// End Remove duplicate size options
const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});
let variantID = params.variant; 
if (variantID){
  const allVariants = document.querySelector('[data-variant-json]');
  if( allVariants?.innerHTML ){
    let allVariantsJson = JSON.parse( allVariants.innerHTML );
    
    const selectedVariant = allVariantsJson.find ( f => f.id === Number(variantID) );
    if( selectedVariant ){
      const optionsButton = document.querySelectorAll('[data-variant-input]');
      optionsButton.forEach( optionButton => {
        const value = optionButton.getAttribute('value');
        const optionKe = optionButton.getAttribute('data-index');
        if(value === selectedVariant[optionKe] ){
          if (optionButton?.checked) {
            optionButton.checked = 'checked';          
          }
          setTimeout(() => {
            const label = document.querySelector('[data-variant-color-label]');
            if( label ) label.innerHTML = selectedVariant.option1;
            const newImage = document.querySelector('.product__thumb[data-id="' + selectedVariant.featured_media.id + '"]');
            const imageIndex = newImage.dataset.index;
            flickity.goToSlide(imageIndex)
          }, 500);
        }
      })
    }
  }
}
// Auto selected sub product


// Flickity
// Product dots
setTimeout(() => {
  document.querySelector('.flickity-page-dots')?.addEventListener('change',function(){
    const dots = document.querySelectorAll('.flickity-page-dots .dot');
    // console.log(dots);
  });
}, 1000)
// End Flickity
// End Product dots

// JUDGEME
/*document.addEventListener('DOMNodeInserted', function(e) {
  // review sum movement
  const reviewAvg = document.querySelector(".shopify-app-block .jdgm-preview-badge");
  if( reviewAvg ){
    const judgemeAvg = document.querySelector("#judgeme-avg");
    judgemeAvg.appendChild( reviewAvg );
  }
  // hide star if no review
  const newReviewAvg = document.querySelector("#judgeme-avg .jdgm-preview-badge");
  const newReviewAvgStars = document.querySelector("#judgeme-avg .jdgm-preview-badge .jdgm-prev-badge__stars");
  if( newReviewAvg && newReviewAvg.innerText.includes('first to review') && newReviewAvgStars?.style?.display !== 'none' ){
    newReviewAvgStars.style.display = 'none';
  }
  
  const judgemeReview = document.querySelector("#judgeme_product_reviews");
  const reviewInfoAsk = document.querySelector("#reviewinfo-ask");
  
  const jdgmFormWrapper = document.querySelector('.jdgm-form-wrapper');
  if( judgemeReview && !reviewInfoAsk && jdgmFormWrapper ){
    
    let reviewInfoAsk = document.createElement('div');
    reviewInfoAsk.id = 'reviewinfo-ask';
    let reviewInfoAskText = document.createTextNode("How happy are you with this item ?");
    reviewInfoAsk.appendChild(reviewInfoAskText);
    jdgmFormWrapper.prepend(reviewInfoAsk);

    document.querySelector('.jdgm-rev-widg__title').innerHTML = "Ratings And Reviews";
    
    // get title product and create span title for reviews info
    const title = document.querySelector('#judgeme-avg span').innerHTML;
    let spanTitle = document.createElement('span');
    let spanTitleText = document.createTextNode(title?.replace('|', ''));
    spanTitle.appendChild(spanTitleText);
    // reviews info
    let reviewInfo = document.createElement('div');
    reviewInfo.id = 'review-product-info';
    let reviewInfoText = document.createTextNode("You're Reviewing: ");
    reviewInfo.appendChild(reviewInfoText);
    reviewInfo.appendChild(spanTitle);
    jdgmFormWrapper.prepend(reviewInfo);

    // review start movement 
    const reviewForm = document.querySelector(".jdgm-form");
    const starFill = document.querySelector(".jdgm-form__rating-fieldset");
    if ( false ) reviewForm.prepend( starFill )
    
    // review sort movement
    const sortOption = document.querySelector(".jdgm-rev-widg__sort-wrapper");
    const reviewHeader = document.querySelector(".jdgm-rev-widg__header");
    if ( sortOption ) reviewHeader.append( sortOption );

    // required label
    const requiredLabel = document.createElement('span');
    requiredLabel.className = 'required-label';
    let requiredLabelText = document.createTextNode(" *");
    requiredLabel.appendChild(requiredLabelText);

    if( false ){
      document.querySelector(".jdgm-form__name-fieldset label")?.appendChild(requiredLabel.cloneNode(true));
      document.querySelector(".jdgm-form__email-fieldset label")?.appendChild(requiredLabel.cloneNode(true));
      document.querySelector(".jdgm-form__body-fieldset label")?.appendChild(requiredLabel.cloneNode(true)); 
    }
  }
  
  // Set review title value
  const reviewTitle = document.querySelector("input[name='review_title']");
  if( reviewTitle && reviewTitle.value !== "Judge.me" ) {
    const reviewTitleWrapper = document.querySelector( ".jdgm-form__title-fieldset" );
    if (reviewTitleWrapper?.style) {
      reviewTitleWrapper.style.display = "none";
    }
    reviewTitle.value = "Judge.me";
  }
  // Remove default button review 2 (for check whether still show )
   const writeReviewButton = document.querySelector(".jdgm-widget-actions-wrapper");
    if(writeReviewButton?.style) {
    writeReviewButton.style.display = "none";
  }
});

// Remove default button review 1
document.addEventListener('readystatechange', (event) => {
  const writeReviewButton = document.querySelector(".jdgm-widget-actions-wrapper");
  if(writeReviewButton?.style) {
    writeReviewButton.style.display = "none";
  }
});*/
// JUDGEME

// JUDGEME --New since DomNodeInserted is deprecated --start
// Select the target node to observe
const targetNode = document.body;

// Create a mutation observer
const observer = new MutationObserver((mutationsList, observer) => {
  mutationsList.forEach(mutation => {
    if (mutation.type === 'childList') {
      // review sum movement
      const reviewAvg = document.querySelector(".shopify-app-block .jdgm-preview-badge");
      if (reviewAvg) {
        const judgemeAvg = document.querySelector("#judgeme-avg");
        judgemeAvg.appendChild(reviewAvg);
      }
      
      // hide star if no review
      const newReviewAvg = document.querySelector("#judgeme-avg .jdgm-preview-badge");
      const newReviewAvgStars = document.querySelector("#judgeme-avg .jdgm-preview-badge .jdgm-prev-badge__stars");
      if (newReviewAvg && newReviewAvg.innerText.includes('first to review') && newReviewAvgStars?.style?.display !== 'none') {
        newReviewAvgStars.style.display = 'none';
      }

      const judgemeReview = document.querySelector("#judgeme_product_reviews");
      const reviewInfoAsk = document.querySelector("#reviewinfo-ask");

      const jdgmFormWrapper = document.querySelector('.jdgm-form-wrapper');
      if (judgemeReview && !reviewInfoAsk && jdgmFormWrapper) {

        let reviewInfoAsk = document.createElement('div');
        reviewInfoAsk.id = 'reviewinfo-ask';
        let reviewInfoAskText = document.createTextNode("How happy are you with this item?");
        reviewInfoAsk.appendChild(reviewInfoAskText);
        jdgmFormWrapper.prepend(reviewInfoAsk);

        document.querySelector('.jdgm-rev-widg__title').innerHTML = "Ratings And Reviews";

        // get title product and create span title for reviews info
        const title = document.querySelector('#judgeme-avg span').innerHTML;
        let spanTitle = document.createElement('span');
        let spanTitleText = document.createTextNode(title?.replace('|', ''));
        spanTitle.appendChild(spanTitleText);
        
        // reviews info
        let reviewInfo = document.createElement('div');
        reviewInfo.id = 'review-product-info';
        let reviewInfoText = document.createTextNode("You're Reviewing: ");
        reviewInfo.appendChild(reviewInfoText);
        reviewInfo.appendChild(spanTitle);
        jdgmFormWrapper.prepend(reviewInfo);

        // review start movement
        const reviewForm = document.querySelector(".jdgm-form");
        const starFill = document.querySelector(".jdgm-form__rating-fieldset");
        if (false) reviewForm.prepend(starFill);

        // review sort movement
        const sortOption = document.querySelector(".jdgm-rev-widg__sort-wrapper");
        const reviewHeader = document.querySelector(".jdgm-rev-widg__header");
        if (sortOption) reviewHeader.append(sortOption);

        // required label
        const requiredLabel = document.createElement('span');
        requiredLabel.className = 'required-label';
        let requiredLabelText = document.createTextNode(" *");
        requiredLabel.appendChild(requiredLabelText);

        if (false) {
          document.querySelector(".jdgm-form__name-fieldset label")?.appendChild(requiredLabel.cloneNode(true));
          document.querySelector(".jdgm-form__email-fieldset label")?.appendChild(requiredLabel.cloneNode(true));
          document.querySelector(".jdgm-form__body-fieldset label")?.appendChild(requiredLabel.cloneNode(true));
        }
      }

      // Set review title value
      const reviewTitle = document.querySelector("input[name='review_title']");
      if (reviewTitle && reviewTitle.value !== "Judge.me") {
        const reviewTitleWrapper = document.querySelector(".jdgm-form__title-fieldset");
        if (reviewTitleWrapper?.style) {
          reviewTitleWrapper.style.display = "none";
        }
        reviewTitle.value = "Judge.me";
      }

      // Remove default button review 2 (for check whether still show)
      const writeReviewButton = document.querySelector(".jdgm-widget-actions-wrapper");
      if (writeReviewButton?.style) {
        writeReviewButton.style.display = "none";
      }
    }
  });
});

// Start observing the document body for added/removed nodes
const config = { childList: true, subtree: true };
observer.observe(targetNode, config);

// To stop observing at a later time, call observer.disconnect();
// JUDGEME--End

// WISHLIST PLUS
const headerNav = document.querySelector("#HeaderWrapper");
const profileNav = document.querySelector('.site-nav__expanded-item');
headerNav.addEventListener('DOMNodeInserted', function addSwiper(e) {
  const wislishPlusNav = document.querySelector('.site-nav__item .swym-header-launcher');
  if( wislishPlusNav && profileNav ) {
    profileNav.parentNode.insertBefore(wislishPlusNav, profileNav.nextSibling)
  }
});
// END WISHLIST PLUS

// CHECK AND UPDATE CART
async function updateCartProperties( key, propName, value ) {
  let data_cart = await fetch('/cart.json', {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  data_cart = await data_cart.json();
  
  const data_item = data_cart?.items?.find( f => f.key === key );
  let properties = data_item?.properties;
  if( !properties ) properties = {};

  // temporary after update estimated_shipping to Estimated Shipping Date
  delete properties.estimated_shipping;
  
  properties[propName] = value;

  const updates = {
    id: key,
    properties
  };
  await fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updates),
  });
}
async function checkAndUpdateCart(){
  let cart_data = document.querySelectorAll( '.cart__items .cart__item' );
  if( !cart_data.length ) cart_data = document.querySelectorAll( '.cart__page-col .cart__item' );
  if( !cart_data.length ) return;

  for (const cart_item of cart_data){
    const key = cart_item.dataset.key;
    const id = key?.split(':')[0];
    let inventory = cart_item.querySelector( `.product-inventory-data [data-id='${ id }']` )?.dataset?.quantity;
    
    let item_titles = cart_item.querySelectorAll( `.cart__item-title div` );
    let item_est;
    for( const item_title of item_titles ){
      if( item_title.innerHTML.includes( "Estimated" )){
        item_est = item_title.innerHTML;
      }
    }

    let estText;
    if( item_est ){
      estText = item_est.split( ":" )[ 0 ];
      estText = estText?.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
      estText = estText?.trim();
    }
    const delivery_shipping_value = document.querySelector( `.delivery-shipping-value[data-id='${ key }']` );
    const themeDelivery = delivery_shipping_value.dataset.delivery;
    const themeShipping = delivery_shipping_value.dataset.shipping;
    const metaDelivery = delivery_shipping_value.dataset.metaDelivery;
    const metaShipping = delivery_shipping_value.dataset.metaShipping;

    let est;
    const estimatedDeliveryDate = new Date();
    const estimatedDeliveryDateOption = { day:'numeric', month: "long", year: 'numeric' };
    const toLocaleDateString = (date) => new Date( date ).toLocaleDateString( 'en-US', estimatedDeliveryDateOption );
    if( parseInt( inventory ) > 0 ){
      dayPlus = parseInt( metaDelivery || themeDelivery || 7 );
    } else {
      dayPlus = parseInt( metaShipping || themeShipping || 65 );
    }
    est = toLocaleDateString(estimatedDeliveryDate.setDate(estimatedDeliveryDate.getDate() + dayPlus));
    if( !item_est?.includes( est ) ){ 
      const hasTestSku = cart_item.items.some(item => item.sku && item.sku.includes('TEST'));
        if(hasTestSku) {}else{
      await updateCartProperties( key, estText, est);
        }
    }
  }
}
document.addEventListener("DOMContentLoaded", function() {
  setTimeout( () => checkAndUpdateCart(), 1000 );
});
// CHECK AND UPDATE CART

//ADD CUSTOM CLASS TO BREADCRUMB
if (jQuery('.collection-breadcrumbs').length || jQuery('.custom-collection-header').length ) {
  jQuery('.collection-breadcrumbs').parent().parent().addClass('custom-collection-header')
}
//END ADD CUSTOM CLASS TO BREADCRUMB

//testing for scrollup/down
var header = document.querySelector(".site-header");
var navbarHeight = header.offsetHeight;
var lastScrollTop = 0;

window.onscroll = function() {scrollHide()};

function scrollHide() {
  var st = window.pageYOffset || document.documentElement.scrollTop;
  const currentUrl = window.location.href;
const searchwed = 'wedding';
const searchbm = 'bridesmaid';
  var w = window.innerWidth;

if((currentUrl.includes(searchwed)) || (currentUrl.includes(searchbm))){
  if(w <761){
      if (st > lastScrollTop) {
        header.classList.add('hide');
        
      } else {
        header.classList.remove('hide');
      }
      lastScrollTop = st <= 0 ? 0 : st;
    }
}
  
}